import { css } from 'styled-components'

// Fonts
const fonts = {
  primary: "'neue-haas-grotesk-display', sans-serif"
}

// Font Weights
const fontWeights = {
  medium: 500,
  semiBold: 600,
  bold: 700
}

const fontFaces = css`
  /* The import below includes the following fonts:
  - Neue Haas Grotesk Display Pro 55 Roman
  - Neue Haas Grotesk Display Pro 56 Italic
  - Neue Haas Grotesk Display Pro 65 Medium
  - Neue Haas Grotesk Display Pro 75 Bold */
  @import url('https://use.typekit.net/xvg1mnp.css');
`

export { fonts, fontWeights, fontFaces }
